module.exports = __webpack_public_path__ + "img/Calculate Copy.9dc8fe68.svg";